import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import Navbar from "../Navbar";
import SideBar from "../sidebar/SideBar";
import ApiService from "../../helpers/Services.js"


const AdminLayout = () => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRoles = async () => {
    try {
      setIsLoading(true);
      const data = await ApiService.post("user-management", {
        action: "listRoles",
        payload: { vendor: "AARP" },
      });
      setRoles(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className="main">
      <Navbar />
      <div className="flex">
        <div className="w-333 h-screen">
          {/* Pass the roles as a prop to SideBar */}
          <SideBar roles={roles} isLoading={isLoading} />
        </div>
        <div className="contentContainer bg-white">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
